import { getToken } from "../../utils";
import { BASE_URL } from "../../endpoints";

const setAllocationRequirement = async (
  sub_requirements_biocomponents_in_gasoline: any,
  sub_requirement_advanced_biofuels: any,
  general_requirement: any,
  remaining_quantity: any
) => {
  const token = getToken();
  let valid = false;
  const params = {
    sub_requirements_biocomponents_in_gasoline: sub_requirements_biocomponents_in_gasoline,
    sub_requirement_advanced_biofuels: sub_requirement_advanced_biofuels,
    general_requirement: general_requirement,
    remaining_quantity: remaining_quantity,
  };

  if (token) {
    try {
      const response = await fetch(
        `${BASE_URL}/api/sustainability_reports/set_requirement_allocation`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(params),
        }
      );

      var result = await response.json();
      valid = result && result.success;
    } catch (except) {
      valid = false;
    }
  }

  if (!valid) {
    if (result && result.errors)
      return {
        valid: false,
        message: result.errors,
      };
    return {
      valid: false,
      message: "Something unexpected happened",
    };
  }

  return {
    valid: true,
  };
};

export default setAllocationRequirement;
